import { useEffect, useState } from 'react';
import axios from 'axios';
import OpenandCloseModal from '../TradeCurrency/OpenandCloseModal';
import TrackTransactionStage from './TrackTransactionStage';
import TransactionDetails from './TransactionDetails';
import AllBidders from './AllBidders';
import { toast } from 'react-toastify';
import { getToken } from '../utils';

export const TrackRequest = ({ trackRequestData }) => {
  const { getDataById, bidUsers, handleToggleZindex, setZindex } =
    trackRequestData;
  const [clickedBidChatUser, setClickedBidChatUser] = useState(null);
  const [isShowingBidForm, setIsShowingBidForm] = useState(false);
  const [isShowingAcceptOfferModal, setIsShowingAcceptOfferModal] =
    useState(false);

  const { handleOpenandCloseModal, openModal } = OpenandCloseModal();
  const inputObject = {
    amount: '',
    rate: '',
    message: '',
    cx_transaction_id: getDataById?.id,
  };
  const [inputs, setInputs] = useState(inputObject);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);

  const [isAcceptingOffer, setIsAcceptingOffer] = useState(false);
  const [isShowingRating, setIsShowingRating] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  const [isGettingBid, setIsGettingBid] = useState(false);
  const [bank, setBank] = useState(false);
  const [bidId, setBidId] = useState(0);

  const [allBids, setAllBids] = useState([]);
  const [cxBankAccount, setCxBankAccount] = useState({});
  const [isPaymentConfirmedModal, setIsPaymentConfirmedModal] = useState(false);

  const { token: userToken } = getToken();
  const userId = getToken()?.user?.id;

  // const navigate = useNavigate();

  // Bid button
  const [disableOriginatorBid, setDisableOriginatorBid] = useState(true);
  const [disableBidderBid, setDisableBidderBid] = useState(true);
  //Accept button
  const [disableOriginatorAccept, setDisableOriginatorAccept] = useState(true);
  const [disableBidderAccept, setDisableBidderAccept] = useState(true);

  //for payment button
  const [disablePayButton, setDisablePayButton] = useState(false);

  //Close transaction

  const [disableCloseTransactionButton, setDisableCloseTransactionButton] =
    useState(false);

  const handleChange = (e) => {
    const target = e.target;
    const { value, name } = target;
    setInputs((input) => ({
      ...input,
      [name]: value,
    }));
  };

  const handleShowBankDetails = () => {
    setBank(true);
    setZindex(true);
  };

  const handleHideBankDetails = () => {
    setBank(false);
    setZindex(false);
  };

  const handleSubmitBid = (e) => {
    e.preventDefault();
    setIsSubmiting(true);
    setIsLoading(true);
  };

  const handleShowRating = () => {
    setIsShowingRating(true);
    setZindex(true);
  };
  const handleHideRating = () => {
    setIsShowingRating(false);
    setZindex(false);
  };

  const handleShowandHideBidForm = () => {
    setIsShowingBidForm(!isShowingBidForm);
    handleToggleZindex();
  };

  const handleShowandHideAcceptModal = () => {
    setIsShowingAcceptOfferModal(!isShowingAcceptOfferModal);
    handleToggleZindex();
  };

  const handleShowCloseTansactionModal = () => {
    setIsPaymentConfirmedModal(true);
    setZindex(true);
  };
  const handleHideCloseTransactionModal = () => {
    setIsPaymentConfirmedModal(false);
    setZindex(false);
  };

  const handleAcceptBid = () => {
    setIsAcceptingOffer(true);
  };

  //post bid to bid chart
  useEffect(() => {
    if (isSubmiting) {
      const submitBid = async () => {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/bid/chat-store`,
            {
              amount: inputs.amount,
              rate: inputs.rate,
              message: inputs.message,
              bid_id: bidId,
            },

            {
              headers: { Authorization: `Bearer ${userToken}` },
            }
          );
          // console.log('response', response);
          // setResponseBidData(response.data);
          if (response.status === 200) {
            setSuccessMessage(true);
            setIsLoading(false);
            setIsSubmiting(false);
            setIsShowingBidForm(false);
            setInputs(inputObject);
          }
        } catch (error) {
          setIsLoading(false);
          setIsSubmiting(false);
          console.log(error, 'error now');
        }
      };
      submitBid();
    }
  }, [userToken, isSubmiting, inputObject, inputs]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccessMessage(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [successMessage]);

  //Accept offer
  useEffect(() => {
    let url;
    let data;
    const bidChatUrl = `${process.env.REACT_APP_BASE_URL}/bid/chat-store`;
    const acceptOfferUrl = `${process.env.REACT_APP_BASE_URL}/accepted-offer/store`;

    if (isAcceptingOffer) {
      const acceptOffer = async () => {
        if (getDataById?.transaction_type?.id === 1) {
          if (allBids[0]?.orginator?.id && allBids[0]?.user.id === userId) {
            url = bidChatUrl;
            data = {
              amount: allBids[0]?.amount,
              rate: allBids[0]?.rate,
              message: 'accepted',
              bid_id: bidId,
            };
          } else {
            url = acceptOfferUrl;
            data = {
              amount: allBids[0]?.amount,
              rate: allBids[0]?.rate,
              cx_transaction_id: getDataById?.id,
              bid_chat_id: allBids[0]?.id,
            };
          }
        } else if (getDataById?.transaction_type?.id === 2) {
          if (
            allBids[0].orginator?.id === userId &&
            allBids[0].orginator?.id !== allBids[0]?.user?.id
          ) {
            url = acceptOfferUrl;
            data = {
              amount: allBids[0]?.amount,
              rate: allBids[0]?.rate,
              cx_transaction_id: getDataById?.id,
              bid_chat_id: allBids[0]?.id,
            };
          } else {
            url = bidChatUrl;
            data = {
              amount: allBids[0]?.amount,
              rate: allBids[0]?.rate,
              message: 'accepted',
              bid_id: bidId,
            };
          }
        }

        try {
          const response = await axios.post(url, data, {
            headers: { Authorization: `Bearer ${userToken}` },
          });

          console.log('successfull', response.data);
          isShowingAcceptOfferModal(false);
          setIsAcceptingOffer(false);
        } catch (error) {
          setIsAcceptingOffer(false);
          console.log(error, 'error in now');
        }
      };
      acceptOffer();
    }
  }, [userToken, isAcceptingOffer]);

  // const handleGetBidId = (id, allBid, cxAccount) => {
  //   setBidId(id);
  //   setAllBids(allBid);
  //   setCxBankAccount(cxAccount);
  //   setIsGettingBid(true);
  // };

  // console.log({ allBids });
  //get all bid chat
  // useEffect(() => {
  //   if (isGettingBid) {
  //     const submitBid = async () => {
  //       try {
  //         const response = await axios.post(
  //           "${process.env.REACT_APP_BASE_URL}/bid/chats",
  //           { bid_id: bidId },
  //           {
  //             headers: { Authorization: `Bearer ${userToken}` },
  //           }
  //         );
  //         console.log("biddatabyId", response);
  //         // setAllBids(response.data);
  //         setIsGettingBid(false);
  //       } catch (error) {
  //         console.log(error, "error now");
  //         setAllBids([]);
  //         setIsGettingBid(false);
  //       }
  //     };
  //     submitBid();
  //   }
  // }, [userToken, bidId]);

  // console.log(
  //   bidUsers,
  //   allBids,
  //   bidId,
  //   allBids[0],
  //   cxBankAccount,
  //   getDataById
  // );
  // const currencyId = getDataById?.base_currency?.id;
  // const bidChatAccepted = allBids[0];
  // const viewData = getDataById;

  // let status = 'stapted';
  // const TrackDatas = [
  //   {
  //     tracker: '1',
  //     title: 'Bid Offers',
  //     body: 'Buyer $20,000/800',
  //     button: (
  //       <button
  //         className='py-1.5 bg-b-mc text-p-wh rounded text-xs w-16 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80'
  //         onClick={handleShowandHideBidForm}
  //         disabled={
  //           (getDataById?.originator?.id === userId &&
  //             allBids[0]?.orginator?.id !== allBids[0]?.sender?.id &&
  //             bidUsers[0]?.offer_owner_accepted !== '0') ||
  //           (bidUsers[0]?.user?.id === userId &&
  //             allBids[0]?.orginator?.id === allBids[0]?.sender?.id)
  //         }
  //       >
  //         Bid
  //       </button>
  //     ),
  //   },
  //   {
  //     tracker: '2',
  //     title: 'Accept Offer',
  //     body: 'Accept offer at current rate',

  //     button: (
  //       <button
  //         className='py-1.5 bg-b-mc text-p-wh disabled:bg-p-bk/5 rounded text-xs w-16 hover:bg-b-mc/75 focus:bg-b-mc/80'
  //         onClick={handleShowandHideAcceptModal}
  //         disabled={
  //           (getDataById?.originator?.id === userId &&
  //             allBids[0]?.orginator?.id !== allBids[0]?.sender?.id &&
  //             bidUsers[0]?.offer_owner_accepted !== '0') ||
  //           (bidUsers[0]?.user?.id === userId &&
  //             allBids[0]?.orginator?.id !== allBids[0]?.sender?.id)
  //         }
  //       >
  //         Accept
  //       </button>
  //     ),
  //   },
  //   {
  //     tracker: '3',
  //     title: 'Make Payment',
  //     body: 'Buyer ammount/rate $20,000/800',

  //     button: (
  //       <button
  //         className='py-1.5 bg-b-mc text-p-wh rounded text-xs w-16 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80'
  //         onClick={handleShowBankDetails}
  //         // disabled={
  //         //   (getDataById?.originator?.id === userId &&
  //         //     getDataById?.payment_status?.id !== 3) ||
  //         //   (bidUsers[0]?.user?.id === userId &&
  //         //     getDataById?.transaction_status?.id !== 5)
  //         // }
  //       >
  //         Pay
  //       </button>
  //     ),
  //   },
  //   {
  //     tracker: '4',
  //     title: 'Close transaction',
  //     body: 'Please confirmed that you have recieve payment to close transaction',
  //     button: (
  //       <button
  //         className='py-1.5 bg-b-mc text-p-wh rounded text-xs w-16 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80'
  //         onClick={handleShowCloseTansactionModal}
  //         disabled={
  //           (getDataById?.originator?.id === userId &&
  //             getDataById?.payment_status?.id !== 6) ||
  //           (bidUsers[0]?.user?.id === userId &&
  //             getDataById?.payment_status?.id !== 4)
  //         }
  //       >
  //         Close
  //       </button>
  //     ),
  //   },
  // ];
  // const handlConvertTime = (data) => {
  //   const timestamp = data * 1000;
  //   const date = new Date(timestamp);
  //   return date;
  // };

  // const timestamp = 1903029080 * 1000; // Convert to milliseconds
  // const date = new Date(timestamp);

  // let hours = date.getHours();
  // const minutes = date.getMinutes();
  // const seconds = date.getSeconds();

  // let ampm = hours >= 12 ? 'pm' : 'am';
  // hours %= 12;
  // hours = hours || 12; // Handle midnight

  // const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes
  //   .toString()
  //   .padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${ampm}`;
  // console.log(formattedTime);

  //bid offers
  useEffect(() => {
    if (
      getDataById?.originator?.id === userId &&
      allBids[0]?.orginator?.id === allBids[0]?.sender?.id &&
      bidUsers[0]?.offer_owner_accepted !== '1'
    ) {
      setDisableOriginatorBid(true);
    } else if (
      bidUsers[0]?.user?.id === userId &&
      allBids[0]?.orginator?.id !== allBids[0]?.sender?.id
    ) {
      setDisableBidderBid(true);
    }
  }, [allBids, bidUsers, getDataById?.originator?.id, userId]);

  // Accept Offer
  useEffect(() => {
    if (
      getDataById?.originator?.id === userId &&
      allBids[0]?.orginator?.id === allBids[0]?.sender?.id &&
      bidUsers[0]?.offer_owner_accepted !== '1'
    ) {
      setDisableOriginatorAccept(true);
    } else if (
      bidUsers[0]?.user?.id === userId &&
      allBids[0]?.orginator?.id !== allBids[0]?.sender?.id
    ) {
      setDisableBidderAccept(true);
    }
  }, [allBids, bidUsers, getDataById?.originator?.id, userId]);

  //Pay
  useEffect(() => {
    if (getDataById?.payment_status?.id === 7) {
      setDisablePayButton(true);
    }
  }, [getDataById?.payment_status?.id]);

  //close transaction
  useEffect(() => {
    if (getDataById?.payment_status?.id === 8) {
      setDisableCloseTransactionButton(true);
    }
  }, [getDataById?.payment_status?.id]);
  // function handleFormatDate(dateData) {
  //   const dateString = dateData * 1000; // Assuming this is your input
  //   const date = new Date(dateString);

  //   const months = [
  //     'January',
  //     'February',
  //     'March',
  //     'April',
  //     'May',
  //     'June',
  //     'July',
  //     'August',
  //     'September',
  //     'October',
  //     'November',
  //     'December',
  //   ];

  //   const year = date?.getFullYear();
  //   const month = months[date?.getMonth()];
  //   const day = date?.getDate();

  //   const formattedDate = `${day} ${month}, ${year}`;
  //   return formattedDate;
  // }

  const handleToast = (state, message) => {
    if (state === 'success') {
      toast.success(` ${message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (state === 'error') {
      toast.error(`${message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  return (
    <section className='w-full p-6 flex flex-col gap-12 box-border bg-p-wh shadow-lg rounded-lg'>
      {/* <TestdD /> */}
      <>
        {/* {isShowingBidForm && (
        <div className="fixed left-0 top-0 w-screen h-screen bg-p-bk/50 z-100">
        <form
            className="absolute font-pin top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 gap-6 h-fit transition-all duration-300 box-border bg-p-wh py-12 flex flex-col rounded-lg w-[448px]"
            onSubmit={handleSubmitBid}
          >
            <p className="px-8 pb-2 text-xl border-b-hf font-semibold text-p-bk">
              Place bid on offer
            </p>
            
            <div className="px-8 flex flex-col gap-4">
            <div className="flex flex-col gap-2 w-full col-span-1">
            <label className="text-p-bk/50 text-base font-pin">
            Amount
            </label>
            <div className="relative">
            <input
            type="number"
            className=" focus:b-mc w-full h-14 disabled:bg-f-bk rounded-md border-t-bk border-hf px-4 focus:outline-none focus:ring focus:b-mc"
            name="amount"
            value={inputs.amount.toLocaleString()}
            onChange={handleChange}
            placeholder="0.00"
            disabled={isLoading}
                  />
                  <div className="pr-4 absolute flex flex-row right-0 top-1/2 -translate-y-1/2 gap-2 items-center">
                  <p>{getDataById?.quote_currency?.symbol}</p>
                    <img
                    className="w-5 h-[13px]"
                    src={getDataById?.quote_currency?.country?.flag}
                    />
                    </div>
                    </div>
                    </div>
              <div className="flex flex-col gap-2 w-full">
              <label className="text-p-bk/50 text-base font-pin">Rate</label>
                <div className="relative">
                  <input
                    type="number"
                    className=" focus:b-mc w-full h-14 disabled:bg-f-bk rounded-md border-t-bk border-hf px-4 focus:outline-none focus:ring focus:b-mc"
                    name="rate"
                    value={inputs.rate}
                    onChange={handleChange}
                    placeholder="0.00"
                    disabled={isLoading}
                    />
                    <div className="pr-4 absolute flex flex-row right-0 top-1/2 -translate-y-1/2 gap-2 items-center">
                    <p>{getDataById?.base_currency?.symbol}</p>
                    <img
                      className="w-5 h-[13px]"
                      src={getDataById?.base_currency.country?.flag}
                      />
                      </div>
                      </div>
                      </div>
                      <div className="flex flex-col gap-2 w-full">
                      <label className="text-p-bk/50 text-base font-pin">
                      Message
                      </label>
                      <input
                      type="text"
                      className="focus:outline-none disabled:bg-f-bk focus:ring focus:b-mc w-full h-14 rounded-md border-t-bk border-hf px-4"
                      name="message"
                      value={inputs.message}
                      onChange={handleChange}
                      placeholder="message seller"
                      disabled={isLoading}
                      />
                      </div>
                      <div className=" flex flex-row w-full gap-6 pt-4">
                      <button
                      type="button"
                  className="text-p-bk disabled:text-f-bk hover:bg-t-bk/20 focus:bg-t-bk/28 px-8 py-3 font-semibold disabled:bg-b-mct bg-t-bk/10 rounded-md"
                  onClick={handleShowandHideBidForm}
                >
                Cancel
                </button>
                <button
                  type="submit"
                  className="text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 w-full py-3 font-semibold disabled:bg-b-mct bg-b-mc rounded-md relative"
                  disabled={isLoading}
                >
                  Place bid
                  {isLoading && (
                    <ReactLoading
                    type="cylon"
                    color="#5AC8FA"
                    height={44}
                      width={44}
                      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                      />
                      )}
                      </button>
                      </div>
                      </div>
                      </form>
                      </div>
                    )} */}
        {/* {successMessage && (
        <div className="bg-p-wh px-4 border-l-8 border-green-500 flex flex-row z-99999 items-center py-4 gap-2 fixed mx-auto rounded-lg top-32 drop-shadow-lg left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <img src={success} alt="success" className="w-16" />
        <p className="text-green-500">You have successfully placed a bid</p>
        </div>
      )} */}
      </>

      <div className='flex flex-col gap-6'>
        <div className='flex flex-col lg:flex-row gap-6'>
          <TransactionDetails content={{ getDataById }} />
          <AllBidders
            content={{ getDataById, bidUsers, setClickedBidChatUser }}
          />
        </div>
        <TrackTransactionStage
          content={{
            getDataById,
            handleOpenandCloseModal,
            openModal,
            clickedBidChatUser,
            handleToast,
            userToken,
            bidUsers,
            handleHideRating,
          }}
        />
      </div>
    </section>
  );
};
